<template>
   <div>
      <!-- ME KTHY NESE SBON SCAN AW -->
      <!-- <label v-if="!doubleBarcode" class="inline-flex items-center ">
         <input v-model="notGrabowski" @change="redir()" type="checkbox" class="form-checkbox" checked>
         <span class="ml-2">Not Grabowski </span>
         </label>
         <label v-if="!notGrabowski" class="inline-flex items-center ">
         <input v-model="doubleBarcode" @change="redir()" type="checkbox" class="form-checkbox" checked>
         <span class="ml-2">Double Barcode </span>
         </label> -->

         <span>
            <p class="font-semibold text-lg text-red-700">PLEASE BE CAREFUL WHEN YOU SCAN BARCODES!!!<br> BARCODE COMPARING WORKS ONLY FOR HOME 24 & VENTE
            <br>IF YOU WANT TO ADD ANOTHER CLIENT FOR BARCODE COMPARING PLEASE CONTACT PX DEV TEAM.</p>
            <!-- Barcode comparing doesn't work for Grabowski client as this client doesnt have the same barcodes for packets -->
            <!-- If you want to add another client that have barcode that can be compared add the name of client down near home and vente client -->
         </span>
      <form @submit.prevent="scanIdTowaru">
         <p class="font-semibold py-2">Barcode:</p>
         <input
            class="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="scanWm"
            type="text"
            ref="bar1"
            placeholder="EAN"
            v-model="barcode1"
            />
         <!-- ME KTHY NESE SBON SCAN AW -->
         <!-- <input
            v-if="!notGrabowski"
            v-model="barcode2"
            ref="bar2"
            class="shadow mx-2 appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="barcode2"
            type="text"
            placeholder="Barcode"
            /> -->
            <!-- <div v-if="grabowski == 'reklamacion'"> -->
         <input
            v-if="grabowski == 'isGrabowksi'"
            v-model="barcode2"
            ref="bar2"
            class="shadow mx-2 appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="barcode2"
            type="text"
            placeholder="Barcode"
            />
            <!-- </div> -->
         <button type="submit" hidden
            class="uppercase ml-4 focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
            >
         Scan
         </button>
      </form>
      <div class="py-4">
         <span v-if="!overflow" class="font-semibold text-lg text-green-600">{{
         msg
         }}</span>
         <span v-else class="font-semibold text-lg text-red-700">Overflow</span>
         <span v-if="notFound" class="font-semibold text-lg text-red-700">
         {{ notFound }}</span
            >
      </div>
      <div class="text-right">
         <div class="py-2">
            <router-link
               to="/scan-aw"
               class="bg-teal-400 text-white px-4 py-1 uppercase rounded shadow-lg hover:bg-teal-300">
               Back
            </router-link>
         </div>
      </div>

      <div
         class="align-middle inline-block min-w-full overflow-hidden border border-gray-400"
         >
         <table class="min-w-full">
            <thead>
               <tr>
                  <th
                     class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                     >
                     Nr
                  </th>
                  <th
                     class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                     >
                     Nazwa
                  </th>
                  <th
                     class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                     >
                     Id Towaru
                  </th>
                  <th
                     class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                     >
                     Ean
                  </th>
                  <th
                     class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                     >
                     Scanned
                  </th>
                  <!-- <th
                     class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                     >
                     Iloscfdstw
                     </th> -->
                  <th
                     class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                     >
                     Closed
                  </th>
                  <th class="px-2 py-2 border w-6 border-gray-400 bg-gray-50"></th>
               </tr>
            </thead>
            <tbody v-for="(wm, index) in wms" :key="index.id" class="bg-white">
               <tr>
                  <td
                     class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                     >
                     {{ ++index }}
                  </td>
                  <td
                     class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                     >
                     {{ wm.towp_ttw_nazwa }}
                  </td>
                  <td
                     class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                     >
                     {{ wm.p_ttw_idtowaru }}
                  </td>
                  <td
                     class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                     >
                     {{ wm.towp_ttw_ean }}
                  </td>
                  <td
                     class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                     >
                     {{ wm.scanned }}
                  </td>
                  <!-- <td
                     class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                     >
                     {{ wm.p_wmm_iloscfdstw }}
                     </td> -->
                  <td
                     class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                     >
                     <span v-if="wm.closed == 1" class="text-green-500"
                        ><svg
                           class="scan-status"
                           fill="currentColor"
                           viewBox="0 0 20 20"
                           >
                           <path
                              fill-rule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clip-rule="evenodd"
                              /></svg
                           ></span>
                     <span v-else-if="wm.closed == 2">
                        <svg
                           version="1.1"
                           id="Capa_1"
                           xmlns="http://www.w3.org/2000/svg"
                           xmlns:xlink="http://www.w3.org/1999/xlink"
                           x="0px"
                           y="0px"
                           viewBox="0 0 451.74 451.74"
                           style="enable-background: new 0 0 451.74 451.74"
                           xml:space="preserve"
                           class="scan-status"
                           >
                           <path
                              style="fill: #e24c4b"
                              d="M446.324,367.381L262.857,41.692c-15.644-28.444-58.311-28.444-73.956,0L5.435,367.381
                              c-15.644,28.444,4.267,64,36.978,64h365.511C442.057,429.959,461.968,395.825,446.324,367.381z"
                              />
                           <path
                              style="fill: #ffffff"
                              d="M225.879,63.025l183.467,325.689H42.413L225.879,63.025L225.879,63.025z"
                              />
                           <g>
                              <path
                                 style="fill: #3f4448"
                                 d="M196.013,212.359l11.378,75.378c1.422,8.533,8.533,15.644,18.489,15.644l0,0
                                 c8.533,0,17.067-7.111,18.489-15.644l11.378-75.378c2.844-18.489-11.378-34.133-29.867-34.133l0,0
                                 C207.39,178.225,194.59,193.87,196.013,212.359z"
                                 />
                              <circle
                                 style="fill: #3f4448"
                                 cx="225.879"
                                 cy="336.092"
                                 r="17.067"
                                 />
                           </g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                           <g></g>
                        </svg>
                     </span>
                     <span v-else class="text-red-500"
                        ><svg
                           class="scan-status"
                           fill="currentColor"
                           viewBox="0 0 20 20"
                           >
                           <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                              clip-rule="evenodd"
                              /></svg
                           ></span>
                  </td>
                  <td v-if="isAdmin">
                     <div class="py-2">
                        <button @click="deleteWm(wm.towp_ttw_klucz)">
                        <i class="far fa-trash-alt w-6 h-6"></i>
                        </button>
                     </div>
                  </td>
               </tr>
            </tbody>
         </table>
      </div>
      <!-- Modal -->
      <transition name="fade">
         <main v-if="show1" class="modal antialiased bg-gray-200 text-gray-900 font-sans overflow-x-hidden">
            <div class="relative px-4 min-h-screen md:flex md:items-center md:justify-center">
               <div class="bg-black opacity-25 w-full h-full absolute z-10 inset-0"></div>
               <div class="bg-white rounded-lg md:max-w-md md:mx-auto p-4 fixed inset-x-0 top-0 z-50 mt-20 mx-4 md:relative">
                  <div class="md:flex items-center">
                     <div class="rounded-full border border-gray-300 flex items-center justify-center w-16 h-16 flex-shrink-0 mx-auto">
                        <i class="fas fa-exclamation-triangle text-3xl text-yellow-600"></i>
                     </div>
                     <div class="mt-4 md:mt-0 md:ml-6 text-center md:text-left">
                        <p class="font-bold">2 BARCODES OR 1 BARCODE?</p>
                        <p class="text-sm text-gray-700 mt-1">Please choose below if this <strong>AW</strong> has <strong>2 BARCODES</strong> or not. If you have any trouble contact your manager!
                        </p>
                     </div>
                  </div>
                  <div class="text-center md:text-right mt-4 md:flex md:justify-center">
                     <button @click="checkForGrabowski('isGrabowksi')" class="block w-full md:inline-block md:mx-2 md:w-auto px-4 py-3 md:py-2 bg-teal-200 text-black rounded-lg font-semibold text-sm md:ml-2 md:order-1">2 BARCODES</button>
                     <button @click="checkForGrabowski('notGrabowksi')" class="block w-full md:inline-block md:mx-2 md:w-auto px-4 py-3 md:py-2 bg-red-200 text-red-700 rounded-lg font-semibold text-sm mt-4 md:mt-0 md:order-2">1 BARCODE</button>
                     <button @click="checkForGrabowski('reclamacion')" class="block w-full md:inline-block md:mx-2 md:w-auto px-4 py-3 md:py-2 bg-red-200 text-red-700 rounded-lg font-semibold text-sm mt-4 md:mt-0 md:order-2">Reclamacion</button>
                     <!-- <button @click="newfunc('reclamacion')" class="block w-full md:inline-block md:mx-2 md:w-auto px-4 py-3 md:py-2 bg-red-200 text-red-700 rounded-lg font-semibold text-sm mt-4 md:mt-0 md:order-2">1 BARCODE -->

                  </div>
               </div>
            </div>
         </main>
      </transition>

      <transition name="fade">
         <main v-if="show2" class="modal antialiased bg-gray-200 text-gray-900 font-sans overflow-x-hidden">
            <div class="relative px-4 min-h-screen md:flex md:items-center md:justify-center">
               <div class="bg-black opacity-25 w-full h-full absolute z-10 inset-0"></div>
               <div class="bg-white rounded-lg md:max-w-md md:mx-auto p-4 fixed inset-x-0 top-0 z-50 mt-20 mx-4 md:relative">
                  <div class="md:flex items-center">
                     <div class="rounded-full border border-gray-300 flex items-center justify-center w-16 h-16 flex-shrink-0 mx-auto">
                        <i class="fas fa-times  text-3xl text-red-600"></i>
                     </div>
                     <div class="mt-4 md:mt-0 md:ml-6 text-center md:text-left">
                        <p class="font-bold text-red-700">ERORR</p>
                        <p class="text-sm text-gray-700 mt-1">Acording to our data, your select for <strong>{{grabowskiMessage}}</strong> is incorrect. If your selection is correct but there is a error, please contact with your manager.
                        </p>
                     </div>
                  </div>
                  <button @click="returntoScans()" class="block w-full md:inline-block md:w-auto px-4 py-3 md:py-2 bg-blue-300 rounded-lg font-semibold text-sm mt-4
                        md:mt-0 md:order-3">Return to Scan page</button>
               </div>
            </div>
         </main>
      </transition>
   </div>
</template>
<script>
   import axios from "axios";
   export default {
     data() {
       return {
         notGrabowski: false,
         doubleBarcode: false,
         wms: [],
         id: this.$route.params.tr_idtrans,
         ean: "",
         barcode1: "",
         barcode2: "",
         msg: "",
         overflow: "",
         notFound: "",
         aw_id: JSON.parse(localStorage.getItem('aw-number')),
         audio: new Audio(require("../../assets/audio/error.mp3")),
         audioSuccess: new Audio(require("../../assets/audio/success.mp3")),
         isAdmin: false,
         show1: false,
         show2: false,
         //ME FSHI NESE SBON SCAN AW
         grabowski: this.$route.params.is_grabowski,
         grabowskiMessage: '',
         flag: 0
       };
     },
     created() {
       this.getUser();
       this.getWms();
       this.openModal();
       console.log(this.id);
       this.$nextTick(function () {
         this.$refs.bar1.focus();
       });
     },
     mounted() {
       this.$nextTick(function () {
         this.$refs.bar1.focus();
       });
     },
     methods: {
        newfunc(value)
        {
           console.log(value);
        },
       returntoScans(){
          this.$router.push('/scan-aw');
       },
       checkForGrabowski(value) {
          if(value != 'reclamacion')
          {
               if(this.grabowski == value)
               {
               this.closeModal()
               }
               else
               {
               if(value == 'isGrabowksi')
               {
                  this.grabowskiMessage = '2 Barcodes';
               }
               else
               {
                  this.grabowskiMessage = '1 Barcode';
               }
                  this.closeModal()
                  this.show2 = true
                  document.querySelector("body").classList.add("overflow-hidden");
               }
          }
          else
          {
              this.closeModal()
              this.grabowski = 'notGrabowksi';
          }
              console.log(this.grabowski);
              console.log(this.aw_id);
            //   console.log(!(this.wms[0].tr_nrobcy.includes('GRABOWSKI')));
       },
       closeModal() {
            this.show1 = false;
            document.querySelector("body").classList.remove("overflow-hidden");
          },
          openModal() {
            this.show1 = true;
            document.querySelector("body").classList.add("overflow-hidden");
          },
       getUser() {
         axios.defaults.headers.common["Authorization"] =
         "Bearer " + localStorage.getItem("access_token");
   
         axios.get(`${process.env.VUE_APP_API}/user`).then((response) => {
           // console.log(response);
           if (response.data.data.id === 1 || response.data.data.id === 3) {
             this.isAdmin = true;
           } else {
             this.isAdmin = false;
           }
         });
       },
   
       getWms() {
         axios.defaults.headers.common["Authorization"] =
           "Bearer " + localStorage.getItem("access_token");
         axios
           .get(`${process.env.VUE_APP_API}/wm/${this.id}/${this.aw_id}`)
           .then((response) => {
             this.wms = response.data;
             console.log(response);
           })
           .catch((error) => {
             console.log(error);
           })
           .finally(() => {
             this.$nextTick(function () {
               this.$refs.bar1.focus();
             });
           });
       },
   
       scanIdTowaru() {
         
         this.msg = "";
         this.notFound = "";
         this.overflow = "";
         this.flag = 0;
         if(this.grabowski != 'isGrabowksi') 
         {
            this.flag = 2;
           if(this.barcode1 === "") 
           {
             this.notFound = "EAN is empty";
             this.$nextTick(function () {
               this.$refs.bar1.focus();
             });
           }
           else 
           {
   
             
             axios.defaults.headers.common["Authorization"] =
             "Bearer " + localStorage.getItem("access_token");
             axios
             .post(`${process.env.VUE_APP_API}/scan-wm`, {
               idtr: this.id,
               notGrabowski: this.grabowski,
               id: this.barcode1.trim(),
               aw_id: this.aw_id
             })
             .then((response) => {
               // console.log(response.code);
               this.msg = response.data.message;
               this.overflow = response.data.overflow;
               
               if (response.data.code == 404) {
                 console.log(response);
                 
                 this.error = response.data;
                 this.audio.play();
               } 
               else {
                 this.audioSuccess.play();
                 this.getWms();
               }
             })
             .catch((error) => {
               this.notFound = error.response.data;
               console.log(error);
             })
             .finally(
               (this.barcode1 = ""),
               this.$nextTick(function () {
                 this.$refs.bar1.focus();
               })
             );
           }
         }
         else 
         {
           if(this.barcode1 === "")
           {
             this.notFound = "EAN is empty";
             this.$nextTick(function () {
               this.$refs.bar1.focus();
             });
             this.flag = 1;
             console.log(this.barcode1);
             console.log(this.barcode2);
            //  console.log(this.wms[0].tr_nrobcy);
           }
           else if(this.barcode1 !== "" && this.barcode2 === "")
           {
             this.notFound = "Barcode 2 is empty";
             this.$nextTick(function () {
               this.$refs.bar2.focus();
             });
             this.flag = 1;
             console.log(this.barcode1);
             console.log(this.barcode2);
           }
           else if(this.barcode1 === "" && this.barcode2 !== "")
           {
             this.notFound = "EAN is empty";
             this.$nextTick(function () {
               this.$refs.bar1.focus();
             });
             this.flag = 1;
              console.log(this.barcode1);
             console.log(this.barcode2);
           }
           else if((this.wms[0].tr_nrobcy.includes('HOME')) || (this.wms[0].tr_nrobcy.includes('VENTE')))
            {
               // console.log('ok');
               if(this.barcode1 != this.barcode2)
               {
                  //if there is a problem with scanning this part can be commented/removed
                  this.notFound = "PRODUCT EAN'S ARE NOT THE SAME!!!";
                  this.$nextTick(function () {
                     this.$refs.bar1.focus();
                  });
                  this.flag = 1;
               }
            }
         //   else 
         //   {
            if(this.flag == 0)
            {
             this.notFound = "";
             console.log(`${this.notGrabowski}, ${this.barcode1}, ${this.barcode2} , ${this.id}`)
             axios.defaults.headers.common["Authorization"] =
             "Bearer " + localStorage.getItem("access_token");
             axios
             .post(`${process.env.VUE_APP_API}/scan-wm`, {
               notGrabowski: this.notGrabowski,
               doubleBarcode: this.doubleBarcode,
               idtr: this.id,
               id: this.barcode1.trim(),
               barcode: this.barcode2.trim(),
               aw_id: this.aw_id
             })
             .then((response) => {
               // console.log(response.code);
               this.msg = response.data.message;
               this.overflow = response.data.overflow;
               // if (response.status == 200) {
               //   this.getWms();
               // }
               if (response.data.code == 404) {
                 this.error = response.data;
                 this.audio.play();
               } else {
                 this.audioSuccess.play();
                 this.getWms();
               }
             })
             .catch((error) => {
               this.notFound = "Item not found";
               console.log(error);
               // this.notFound = "";
             })
             .finally(
               (this.barcode1 = ""),
               (this.barcode2 = ""),
               this.$nextTick(function () {
                 this.$refs.bar1.focus();
               })
             );
            }
         //   }
         }
         
       },
   
       redir(){
         if (this.grabowski != 'isGrabowksi')
         {
           this.$nextTick(function () {
             this.$refs.bar1.focus();
           })
         } else 
         {
           this.$nextTick(function () {
             this.$refs.bar1.focus();
           })
         }
       },
   
       deleteWm(code) {
         // console.log('clicked');
          axios.defaults.headers.common["Authorization"] =
           "Bearer " + localStorage.getItem("access_token");
   
         // console.log(code);
         if (confirm("Are you sure?")) {
           axios.post(`${process.env.VUE_APP_API}/delete-wm`, {
             numer: JSON.parse(localStorage.getItem('aw')),
             wm_number: this.id,
             code: code
           })
           .then(() => {
             this.$router.push('/scan-aw');
             this.close();     
           })
           .catch((error) => {
             console.log(error)
           })
   
         }
       },
       
       close() {
         localStorage.removeItem("wm-items");
         localStorage.removeItem("aw");
         localStorage.removeItem("aw-number");
         location.reload();
       }
     
     },
   };
</script>
<style scoped>
   .scan-status {
   width: 30px;
   margin: auto;
   }
</style>
<style lang="scss" scoped>
   .modal {
   overflow-x: hidden;
   overflow-y: auto;
   position: fixed;
   top: 0;
   right: 0;
   bottom: 0;
   left: 0;
   z-index: 9;
   &__backdrop {
   background-color: rgba(0, 0, 0, 0.7);
   position: fixed;
   top: 0;
   right: 0;
   bottom: 0;
   left: 0;
   z-index: 1;
   }
   &__dialog {
   background-color: #ffffff;
   position: relative;
   width: 400px;
   height: 500px;
   margin: 50px auto;
   display: flex;
   flex-direction: column;
   border-radius: 5px;
   z-index: 2;
   @media screen and (max-width: 992px) {
   width: 80%;
   height: 50%;
   padding: 7px;
   }
   }
   &__close {
   width: 30px;
   height: 30px;
   }
   &__header {
   padding: 5px 5px 5px;
   display: flex;
   align-items: flex-start;
   justify-content: space-between;
   }
   &__body {
   padding: 10px 20px 10px;
   overflow: auto;
   display: flex;
   flex-direction: column;
   align-items: stretch;
   }
   &__footer {
   padding: 10px 20px 20px;
   }
   }
   .fade-enter-active,
   .fade-leave-active {
   transition: opacity 0.2s;
   }
   .fade-enter,
   .fade-leave-to {
   opacity: 0;
   }
</style>